const getRoot = state => state.auth;

export const permissions = state => getRoot(state).permissions;
export const permissionsFetching = state => getRoot(state).permissionsFetching;
export const permissionsError = state => getRoot(state).permissionsError;
